import React, { FC } from 'react';
import { NameLinkObject } from '@components/EntityDrawers/constants/empty-objects';
import { ComponentKeys } from '@components/EntityDrawers/drawers/Component/keys';
import ControlledInputGroups, {
  InputsBlockProps,
} from '@components/Inputs/controllers/ControlledInputGroups/ControlledInputGroups';
import ControlledLinkInput from '@components/Inputs/controllers/ControlledLinkInput';
import ControlledTextField from '@components/Inputs/controllers/ControlledTextField';
import { useProject } from '@context/Project/ProjectProvider';
import { getInputGroupsProps } from '@utils/helpers';

const AuditFindingInputs: FC<InputsBlockProps> = ({ createName, viewOnly }) => (
  <>
    <ControlledTextField
      name={createName('name')}
      label="Audit finding name"
      placeholder="Audit finding name"
      disabled={viewOnly}
      multiline
    />

    <ControlledLinkInput
      name={createName('link')}
      label="Audit finding documentation link"
      placeholder="Audit finding documentation link"
      disabled={viewOnly}
      multiline
    />
  </>
);

const AuditFindingGroup: FC = () => {
  const { viewOnly } = useProject();

  return (
    <ControlledInputGroups
      name={ComponentKeys.AuditFinding}
      viewOnly={viewOnly}
      groupObject={NameLinkObject}
      {...getInputGroupsProps('audit finding')}
    >
      {AuditFindingInputs}
    </ControlledInputGroups>
  );
};

export default AuditFindingGroup;
